export const ORDER_PROCESSING_REQUEST=`ORDER_PROCESSING_REQUEST`;
export const ORDER_SAVED=`ORDER_SAVED`;